let navigateRef = null;
let pendingPath = null;

export const setNavigateRef = (fn) => {
  navigateRef = fn;
  // Si había una navegación pendiente, hacela ahora
  if (pendingPath) {
    fn(pendingPath);
    pendingPath = null;
  }
};

export const globalNavigate = (path) => {
  if (navigateRef) {
    navigateRef(path);
  } else {
    // En Electron NO hagas window.location.href = ...!
    pendingPath = path;
    console.warn('⚠️ navigateRef no está inicializado. Guardando navegación pendiente a:', path);
  }
};
